module.exports = new Promise((resolve) => {
    const script = document.createElement('script');
    let settled = false;
    const fail = (message) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      console.warn(message);
      resolve({
        get: () => Promise.reject(new Error(message)),
        init: () => undefined
      });
    };
    script.src = 'https://app.bellwetherit.com/assets/standards/remoteEntry.current.js';
    script.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      resolve({
        get: (request) => window['standards']
          ? window['standards'].get(request)
          : Promise.reject(new Error('Module standards not available')),
        init: (shareScope) => {
          try {
            return window['standards'] ? window['standards'].init(shareScope) : undefined;
          } catch (error) {
            console.warn('standards init failed:', error);
            return undefined;
          }
        }
      });
    };
    script.onerror = () => fail('Failed to load remote: standards');
    const deadline = setTimeout(() => fail('Timed out loading remote: standards'), 10000);
    document.head.appendChild(script);
  });